<template>
    <div class="content" id="content">
        <div class="card">
            <h1 class="title">Acceso Panimiel</h1>
            <form action class="form" @submit.prevent="login">

                <v-text-field
                        v-model="infoform.username"
                        color="orange"
                        label="Nombre de usuario*"
                        required
                ></v-text-field>

                <v-text-field
                        v-model="infoform.password"
                        color="orange"
                        type="password"
                        label="Contraseña*"
                        required
                ></v-text-field>

                <p v-if="error" class="text-red">Has introducido mal el nombre de usuario y/o la contraseña.</p>


                <input class="btn btn-yellow" type="submit" value="ACCEDER">



                <!--label class="form-label" for="#username">Nombre de usuario:</label>
                <input
                        v-model="infoform.username"
                        class="form-input"

                        id="username"
                        required
                        placeholder="Nombre de usuario"
                >
                <label class="form-label" for="#password">Password:</label>
                <input
                        v-model="infoform.password"
                        class="form-input"
                        type="password"
                        id="password"
                        placeholder="Contraseña"
                >

                <input class="form-submit" type="submit" value="Login"-->
            </form>
        </div>
    </div>
</template>

<script>

import auth from "@/libs/auth";
import axios from "axios";
//import Cookies from "js-cookie";

export default {
  data: () => ({

  infoform: {
        username: '',
        password: '',
    },





    error: false,
    response: null
  }),
  methods: {
    login() {

        axios.post('https://appws.panimiel.com/new/index.php/api/users', this.infoform).then((response) => {
          // alert(response.data)

           auth.setUserLogged(response.data)

         //  alert(auth.getUserLogged())

         //  Cookies.set("userLogged", "token");

      //     alert(Cookies.get("userLogged"))
           this.$router.push("/")
        })
        .catch((error) => {

            if (error.response.status != 500){
                this.error = true
            }else{
                alert('Error, no ha sido posible acceder. Consulta con el administrador.')
            }

         })


    /*  console.log(this.password);*/
    }
  }
};
</script>

<!--style scoped>
.login {
  padding: 2rem;
}
.title {
  text-align: center;
}
.form {
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
  min-width: 350px;
  max-width: 100%;
  background: rgba(19, 35, 47, 0.9);
  border-radius: 5px;
  padding: 40px;
  box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.3);
}
.form-label {
  margin-top: 2rem;
  color: white;
  margin-bottom: 0.5rem;
  &:first-of-type {
    margin-top: 0rem;
  }
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid white;
  color: white;
  &:focus {
    outline: 0;
    border-color: #1ab188;
  }
}
.form-submit {
  background: #1ab188;
  border: none;
  color: white;
  margin-top: 3rem;
  padding: 1rem 0;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #0b9185;
  }
}
</style-->